import { Component, HostListener, OnDestroy, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core'
import { PageError } from '@app/pages/page-error/interface/page-error'
import { PageErrorService } from './service/page-error.service'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { Portal, PortalModule, TemplatePortal } from '@angular/cdk/portal'
import { FciErrorType } from '@core/api/fci-error-type'
import { UiModal } from '@app/models/ui-modal'

import { DirectivesModule } from '@app/directives/directives.module'
import { ErrorContentComponent } from '@app/pages/page-error/error-content/error-content.component'

@Component({
  selector: 'app-error',
  imports: [DirectivesModule, PortalModule, ErrorContentComponent],
  templateUrl: './page-error.component.html',
  styleUrls: ['./page-error.component.scss'],
})
export class PageErrorComponent implements OnDestroy {
  public FciErrorType = FciErrorType
  public pageError: PageError
  public selectedPortal: Portal<any>
  public instance: UiModal
  @ViewChild('errorModalTemplate', { static: true }) errorModalTemplate: TemplateRef<any>
  private destroy$ = new Subject<void>()

  constructor(
    private pageErrorService: PageErrorService,
    private viewContainerRef: ViewContainerRef
  ) {
    this.pageErrorService.notification$.pipe(takeUntil(this.destroy$)).subscribe((incomePageError) => {
      if (incomePageError) {
        // Ignore Page Error Notification if any one exists
        if (this.pageError) {
          return
        }

        this.pageError = incomePageError

        if (this.pageError.fciErrorType !== FciErrorType.emptyContent) {
          this.showErrorModal()
        }
      } else {
        // Clear Page Error Notification
        this.clear()
      }
    })
  }

  @HostListener('window:popstate', ['$event'])
  onPopState() {
    this.clear()
  }

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }

  public errorModalHandler(instance: UiModal) {
    this.instance = instance
    this.instance?.open?.()
  }

  public clear() {
    // Clear Page Error Notification
    this.instance?.close?.()
    this.pageError = null
  }

  private showErrorModal() {
    this.selectedPortal = new TemplatePortal(this.errorModalTemplate, this.viewContainerRef)
  }
}
